export const ROOT_NODE_ID = ':ROOT:';
export const SelectionMode = {
    NULL: null,
    SINGLE: 'single',
    SINGLE_RADIO: 'single-radio',
    SINGLE_RADIO_HIERARCHY: 'single-radio-hierarchy',
    MULTI: 'multi',
    MULTI_HIERARCHY: 'multi-hierarchy',
    TOP_HIERARCHY: 'top-hierarchy',
    LOW_HIERARCHY: 'low-hierarchy',
    PERMISSION_LOW_HIERARCHY: 'permission-low-hierarchy',
};
export const isRootNode = node => (node === null || node === void 0 ? void 0 : node.id) === ROOT_NODE_ID;
